import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PDFDocumentProxy} from 'ng2-pdf-viewer';
import { finalize, catchError, timeout } from 'rxjs/operators';
import {ApiService} from '../../../services/api.service';
import {TemplateService} from '../../../services/template.service';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
import {API_CONSTANT} from '../../../services/api.constant';

@Component({
  selector: 'app-document-issue',
  templateUrl: './document-issue.component.html',
  styleUrls: ['./document-issue.component.scss'],
  providers: [TemplateService]
})
export class DocumentIssueComponent implements OnInit {
  username = localStorage.getItem('username');

  buyerBranchID: string;
  documentTypes = this.template.get().filter(doc => doc.type !== 'delivery_order_tax_invoice');
  selectedDocumentType: any;

  step = 1;

  pdf: any;
  pdfPage = 1;
  pdfPageLength: number;
  pdfError: string;
  pdfLoaded = false;
  pdfPath: string;

  documentFormData: any;
  isLoading = false;
  timeOut: string;
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private apiService: ApiService,
    private template: TemplateService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.buyerBranchID = params['buyer_branch'];
    });
  }

  selectDocumentType(type) {
    this.selectedDocumentType = type;
    this.step = 2;
  }

  setPDF(pdf: PDFDocumentProxy) {
    this.pdfPageLength = pdf.numPages;
    this.pdfLoaded = true;
  }

  resetPDF() {
    this.pdfLoaded = false;
    this.pdfPage = 1;
    this.pdfError = undefined;
  }

  nextPage() {
    if (this.pdfPage < this.pdfPageLength) {
      this.pdfPage++;
    }
  }

  prevPage() {
    if (this.pdfPage > 1) {
      this.pdfPage--;
    }
  }

  createETaxInvoice() {
    this.isLoading = true;

    this.resetPDF();

    this.apiService.createETaxInvoice(this.documentFormData)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (res: any) => {
          this.pdfPath = res.pdf_file;
          this.pdf = {
            url: res.pdf_file,
            httpHeaders: {Authorization: 'Bearer' + ' ' + localStorage.getItem('currentUser')},
            withCredentials: true
          };

          if (!this.documentFormData.preview) {
            this.sniff('CREATE_DOC', this.username);
          }
        },
        (err: any) => {
          const duplicate_branch_name = 'duplicate key value violates unique constraint';

          if (err.error.includes(duplicate_branch_name)) {
            this.pdfError = 'Buyer Name already has Branch Name with another Branch Code';
          } else {
            this.pdfError = err.error;
          }
        }
      );
  }

  previewPDF(data: any) {
    this.documentFormData = data;

    if (this.documentFormData) {
      this.step = 3;
      this.documentFormData['preview'] = true;

      this.createETaxInvoice();
    } else {
      this.step = 1;
    }
  }

  editDoc() {
    this.step = 2;
    this.pdf = undefined;
    window.scrollTo(0, 0);
  }

  submitDoc() {
    this.step = 4;

    this.documentFormData['preview'] = false;

    this.createETaxInvoice();
  }

  startOver() {
    this.step = 1;
    this.pdf = undefined;
  }

  print() {
    this.apiService.getFileFullPath(this.pdfPath).subscribe(
      (blob: Blob) => {
        const rdDocType = this.documentFormData.file_type;
        const invoiceNumber = this.documentFormData.invoice_number;
        const issueDt = this.documentFormData.issue_dt.slice(0, 10).replace(/-/gi, '_');
        const fileName = `${invoiceNumber}_${rdDocType}_${issueDt}.pdf`;
        this.apiService.createDownloadFile(blob, fileName);
        this.sniff('CLICK_PRINT', this.documentFormData.invoice_number);
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  sniff(action: string, target: string) {
    const data = {
      action: action,
      address: 'DOC_ISSUE',
      target: target
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/document-issue.component.ts